/* Desktop product gallery. The main picture row is swipeable like on phones: trackpads and touch screens scroll it
   natively (see product-gallery-dior.css). A mouse cannot swipe, so this lets it click and drag the picture to the
   next or the previous one; letting go slides to the picture it lands on. Phones and tablets are left alone. */
(function () {
  if (window.__elanoraGallerySwipe) return;
  window.__elanoraGallerySwipe = true;

  var desktop = window.matchMedia('(min-width: 990px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setUp(list) {
    if (list.getAttribute('data-swipe-ready')) return;
    list.setAttribute('data-swipe-ready', 'true');

    var pointerId = null;
    var startX = 0;
    var lastX = 0;
    var startLeft = 0;
    var startIndex = 0;
    var startTime = 0;
    var dragged = false;
    var swallowClick = false;

    /* The pictures are lazy by default; on desktop they are all fetched up front, so a swipe never shows an
       empty frame. */
    if (desktop.matches) {
      list.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    function slides() {
      return list.querySelectorAll('.product__media-item');
    }

    /* Snapping is switched off while a picture is dragged and while it slides into place, then comes back. */
    function restoreSnap() {
      if (dragged) return;
      list.style.scrollSnapType = '';
      list.style.scrollBehavior = '';
    }

    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !desktop.matches) return;
      pointerId = e.pointerId;
      startX = lastX = e.clientX;
      startLeft = list.scrollLeft;
      startIndex = Math.round(startLeft / list.clientWidth);
      startTime = Date.now();
      dragged = false;
    });

    window.addEventListener('pointermove', function (e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      lastX = e.clientX;
      var dx = lastX - startX;
      if (!dragged) {
        if (Math.abs(dx) < 5) return;
        dragged = true;
        list.classList.add('is-dragging');
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        document.documentElement.style.webkitUserSelect = 'none';
        document.documentElement.style.userSelect = 'none';
      }
      list.scrollLeft = startLeft - dx;
    });

    function release(e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      pointerId = null;
      if (!dragged) return;
      dragged = false;

      list.classList.remove('is-dragging');
      document.documentElement.style.webkitUserSelect = '';
      document.documentElement.style.userSelect = '';

      /* A drag of about a seventh of the picture's width (or a quick flick) goes to the next or the previous
         picture; a shorter one slides back to where it started. */
      var items = slides();
      var width = list.clientWidth;
      var dx = lastX - startX;
      var flick = Math.abs(dx) > 20 && Math.abs(dx) / Math.max(1, Date.now() - startTime) > 0.35;
      var index = startIndex;
      if (Math.abs(dx) > Math.min(80, width * 0.15) || flick) index += dx < 0 ? 1 : -1;
      index = Math.max(0, Math.min(items.length - 1, index));

      list.scrollTo({ left: items[index].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      setTimeout(restoreSnap, 650);

      /* The click that follows letting go must not count as a click on the picture. */
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 0);
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    list.addEventListener('click', function (e) {
      if (!swallowClick) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function setUpAll() {
    document.querySelectorAll('media-gallery [id^="Slider-Gallery"]').forEach(setUp);
  }

  setUpAll();
  document.addEventListener('shopify:section:load', setUpAll);
})();
